import { render, staticRenderFns } from "./input-range.vue?vue&type=template&id=39fc97fa&"
import script from "./input-range.vue?vue&type=script&lang=js&"
export * from "./input-range.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports